<template>
  <section class="h_76">
    <div class="title f-center-title">
      <div>无界互联</div>
      <div>打破品牌壁垒</div>
    </div>
    <div class="video_container" v-ia>
      <div class="video_content">
        <m-video
          src="@/v2/mobile/assets/video/v_76.mp4"
          poster="@/v2/mobile/assets/video/poster/v_76.webp"
          disablepictureinpicture
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video)"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'

export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleAreaH5(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_76 {
  z-index: 14;
  height: auto;
  position: relative;
  background: #fff;
  .title {
    margin: 0 24px;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.5;
    padding-top: 100px;
    background: radial-gradient(
      183.11% 411.81% at 24.05% -41.32%,
      #0066ff 0%,
      #00d66b 99.5%
    );
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    font-weight: 700;
  }
  .video_container {
    width: calc(100% - 48px);
    position: relative;
    overflow: hidden;
    margin: 0 24px;
    .video_content {
      position: relative;
      width: 100%;
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-bottom-width: 20px;
        border-color: black;
        z-index: 1;
      }
    }
    video {
      width: 100%;
      height: auto;
      display: block;
    }
    .alive_replay {
      bottom: 9%;
      margin-top: 24px;
      z-index: 1;
      color: #3b82fc;
    }
  }
}
</style>
